import { render, staticRenderFns } from "./payCodeDetail.vue?vue&type=template&id=476074be&"
import script from "./payCodeDetail.vue?vue&type=script&lang=js&"
export * from "./payCodeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports